import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfPaymentTermCustomer(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    {
      header: "PAYMENT TERM CUSTOMER",
      key: "payment_term_customer",
      width: 10,
    },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.payment_term_code ?? "-",
    payment_term_customer: item.payment_term_name
      ? `${item.payment_term_name} Day`
      : "-",
    description: item.description ?? "-",
  }));

  return (
    <PdfTemplate
      data={dataMap}
      column={columns}
      title="Payment Term Customer"
    />
  );
}
